import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import MeasurementUnit from '@square/dashboard-data/models/connect/measurement-unit';
export default ProtoBaseModel.extend({
  measurementUnit: attr(MeasurementUnit),
  precision: attr(Number),
  catalogObjectId: attr(String),
  catalogObjectVersion: attr(Number)
});